// Class: starling.rendering.VertexDataAttribute

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $import = require("./../../import_stub").default;
function haxe_ds_StringMap() {return require("./../../haxe/ds/StringMap");}
function js__$Boot_HaxeError() {return require("./../../js/_Boot/HaxeError");}
function openfl_errors_ArgumentError() {return $import(require("openfl/errors/ArgumentError"));}

// Constructor

var VertexDataAttribute = function(name,format,offset) {
	if(VertexDataAttribute.FORMAT_SIZES == null) {
		var _g = new (haxe_ds_StringMap().default)();
		_g.set("bytes4",4);
		_g.set("float1",4);
		_g.set("float2",8);
		_g.set("float3",12);
		_g.set("float4",16);
		VertexDataAttribute.FORMAT_SIZES = _g;
	}
	if(!VertexDataAttribute.FORMAT_SIZES.exists(format)) {
		throw new (js__$Boot_HaxeError().default)(new (openfl_errors_ArgumentError().default)("Invalid attribute format: " + format + ". " + "Use one of the following: 'float1'-'float4', 'bytes4'"));
	}
	this.name = name;
	this.format = format;
	this.offset = offset;
	this.size = VertexDataAttribute.FORMAT_SIZES.get(format);
	this.isColor = name.indexOf("color") != -1 || name.indexOf("Color") != -1;
}

// Meta

VertexDataAttribute.__name__ = ["starling","rendering","VertexDataAttribute"];
VertexDataAttribute.prototype = {
	
};
VertexDataAttribute.prototype.__class__ = VertexDataAttribute.prototype.constructor = $hxClasses["starling.rendering.VertexDataAttribute"] = VertexDataAttribute;

// Init



// Statics




// Export

exports.default = VertexDataAttribute;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/starling/rendering/VertexDataAttribute.js
// module id = 111
// module chunks = 0